import { Scenarios } from '@jfs/network'

const getBankIfscList = {
  default: [
    {
      url: /remittance\/jpb\/v2\/crm\/getBanksByOrder/,
      method: 'GET',
      response: [
        {
          bankName: 'BANK OF AMERICA',
          bankCode: 16,
          defaultIfsc: 'ICIC0007246',
        },
        {
          bankName: 'AXIS BANK',
          bankCode: 13,
          defaultIfsc: 'ICIC0007246',
        },
        {
          bankName: 'DEUSTCHE BANK',
          bankCode: 41,
          defaultIfsc: 'IDFC0007246',
        },
        {
          bankName: 'ANDHRA PRAGATHI GRAMEENA BANK',
          bankCode: 9,
          defaultIfsc: null,
        },
        {
          bankName: 'HDFC BANK',
          bankCode: 53,
          defaultIfsc: null,
        },
        {
          bankName: 'BANK OF INDIA',
          bankCode: 20,
          defaultIfsc: null,
        },
        {
          bankName: 'CITI BANK',
          bankCode: 31,
          defaultIfsc: null,
        },
        {
          bankName: 'CANARA BANK',
          bankCode: 26,
          defaultIfsc: null,
        },
        {
          bankName: 'AU SMALL FINANCE BANK LIMITED',
          bankCode: 11,
          defaultIfsc: null,
        },
        {
          bankName: 'BARCLAYS BANK',
          bankCode: 23,
          defaultIfsc: null,
        },
        {
          bankName: 'AHMEDABAD MERCANTILE COOPERATIVE BANK',
          bankCode: 3,
          defaultIfsc: null,
        },
        {
          bankName: 'AKOLA JANATA COMMERCIAL COOPERATIVE BANK',
          bankCode: 5,
          defaultIfsc: null,
        },
        {
          bankName: 'BANK OF BAHARAIN AND KUWAIT BSC',
          bankCode: 17,
          defaultIfsc: null,
        },
        {
          bankName: 'CAPITAL SMALL FINANCE BANK LIMITED',
          bankCode: 27,
          defaultIfsc: null,
        },
        {
          bankName: 'BANK OF TOKYO MITSUBISHI LIMITED',
          bankCode: 22,
          defaultIfsc: null,
        },
        {
          bankName: 'ALMORA URBAN COOPERATIVE BANK LIMITED',
          bankCode: 7,
          defaultIfsc: null,
        },
        {
          bankName: 'AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED',
          bankCode: 12,
          defaultIfsc: null,
        },
        {
          bankName: 'BANK OF MAHARASHTRA',
          bankCode: 21,
          defaultIfsc: null,
        },
        {
          bankName: 'BHARAT COOPERATIVE BANK MUMBAI LIMITED',
          bankCode: 25,
          defaultIfsc: null,
        },
        {
          bankName: 'EXPORT IMPORT BANK OF INDIA',
          bankCode: 49,
          defaultIfsc: null,
        },
        {
          bankName: 'DEPOSIT INSURANCE AND CREDIT GUARANTEE CORPORATION',
          bankCode: 40,
          defaultIfsc: null,
        },
        {
          bankName: 'AIRTEL PAYMENTS BANK LIMITED',
          bankCode: 4,
          defaultIfsc: null,
        },
        {
          bankName: 'DOHA BANK',
          bankCode: 44,
          defaultIfsc: null,
        },
        {
          bankName: 'ESAF SMALL FINANCE BANK LIMITED',
          bankCode: 48,
          defaultIfsc: null,
        },
        {
          bankName: 'ABHYUDAYA COOPERATIVE BANK LIMITED',
          bankCode: 1,
          defaultIfsc: null,
        },
        {
          bankName: 'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK CALYON BANK',
          bankCode: 35,
          defaultIfsc: null,
        },
        {
          bankName: 'ABU DHABI COMMERCIAL BANK',
          bankCode: 2,
          defaultIfsc: null,
        },
        {
          bankName: 'DHA0LAKSHMI BANK',
          bankCode: 43,
          defaultIfsc: null,
        },
        {
          bankName: 'BANDHAN BANK LIMITED',
          bankCode: 15,
          defaultIfsc: null,
        },
        {
          bankName: 'CHI0TRUST COMMERCIAL BANK LIMITED',
          bankCode: 30,
          defaultIfsc: null,
        },
        {
          bankName: 'DENA BANK',
          bankCode: 38,
          defaultIfsc: null,
        },
        {
          bankName: 'FEDERAL BANK',
          bankCode: 50,
          defaultIfsc: null,
        },
        {
          bankName: 'ALLAHABAD BANK',
          bankCode: 6,
          defaultIfsc: null,
        },
        {
          bankName: 'FIRSTRAND BANK LIMITED',
          bankCode: 51,
          defaultIfsc: null,
        },
        {
          bankName: 'B N P PARIBAS',
          bankCode: 14,
          defaultIfsc: null,
        },
        {
          bankName: 'CITIZEN CREDIT COOPERATIVE BANK LIMITED',
          bankCode: 32,
          defaultIfsc: null,
        },
        {
          bankName: 'BASSEIN CATHOLIC COOPERATIVE BANK LIMITED',
          bankCode: 24,
          defaultIfsc: null,
        },
        {
          bankName: 'DOHA BANK QSC',
          bankCode: 45,
          defaultIfsc: null,
        },
        {
          bankName: 'CREDIT SUISEE AG',
          bankCode: 36,
          defaultIfsc: null,
        },
        {
          bankName: 'DEOGIRI 0GARI SAHAKARI BANK LTD. AURANGABAD',
          bankCode: 39,
          defaultIfsc: null,
        },
        {
          bankName: 'BANK OF CEYLON',
          bankCode: 19,
          defaultIfsc: null,
        },
        {
          bankName: 'G P PARSIK BANK',
          bankCode: 52,
          defaultIfsc: null,
        },
        {
          bankName: 'CATHOLIC SYRIAN BANK LIMITED',
          bankCode: 28,
          defaultIfsc: null,
        },
        {
          bankName: 'EQUITAS SMALL FI0NCE BANK LIMITED',
          bankCode: 47,
          defaultIfsc: null,
        },
        {
          bankName: 'CENTRAL BANK OF INDIA',
          bankCode: 29,
          defaultIfsc: null,
        },
        {
          bankName: 'BANK OF BARODA',
          bankCode: 18,
          defaultIfsc: null,
        },
        {
          bankName: 'ANDHRA BANK',
          bankCode: 8,
          defaultIfsc: null,
        },
        {
          bankName: 'DOMBIVLI NAGARIK SAHAKARI BANK LIMITED',
          bankCode: 46,
          defaultIfsc: null,
        },
        {
          bankName: 'APNA SAHAKARI BANK LIMITED',
          bankCode: 10,
          defaultIfsc: null,
        },
        {
          bankName: 'CITY UNION BANK LIMITED',
          bankCode: 33,
          defaultIfsc: null,
        },
        {
          bankName: 'DCB BANK LIMITED',
          bankCode: 37,
          defaultIfsc: null,
        },
        {
          bankName: 'CORPORATION BANK',
          bankCode: 34,
          defaultIfsc: null,
        },
        {
          bankName: 'DEVELOPMENT BANK OF SINGAPORE',
          bankCode: 42,
          defaultIfsc: null,
        },
      ],
      delay: 500,
    },
  ],
  failed: [
    {
      url: /remittance\/jpb\/v2\/crm\/getBanksByOrder/,
      method: 'GET',
      responseCode: 500,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getBankIfscList }
